import { useMemo } from 'react';

const useErrorCodePrivacyPolicy = () => {
  const ERROR_CODE_POLICY_POLICY = useMemo(() => {
    return {
      '404_PRIVACY_POLICY_NOT_FOUND': {
        message: '404_PRIVACY_POLICY_NOT_FOUND',
        statusCode: 400,
        type: 'error',
      },
    };
  }, []);
  return {
    ERROR_CODE_POLICY_POLICY,
  };
};

export default useErrorCodePrivacyPolicy;
